module.exports = __webpack_public_path__ + "card-stack.png?9d8d2f52aa91a49f71babfb0b57dc00e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/card-stack.png
// module id = 577
// module chunks = 0